export const AUDIO_EXT = ["mp3", "flac", "m4a", "m4b", "mp4", "aac", "ogg", "oga", "opus", "wav", "aiff", "aif", "wma", "webm", "weba"];
const IMAGE_EXT = ["jpg", "jpeg", "png", "webp"];
const COVER_NAMES = ["cover", "folder", "front", "albumart", "album"];

const ext = (name) => name.split(".").pop().toLowerCase();
const stem = (name) => name.replace(/\.[^.]+$/, "").toLowerCase();

const readEntries = (reader) => new Promise((res, rej) => reader.readEntries(res, rej));
const entryFile = (entry) => new Promise((res, rej) => entry.file(res, rej));

async function walk(entry, dir, out) {
  if (entry.isFile) {
    out.push({ file: await entryFile(entry), dir });
  } else if (entry.isDirectory) {
    const reader = entry.createReader();
    const sub = dir ? `${dir}/${entry.name}` : entry.name;
    let batch;
    do {
      batch = await readEntries(reader);
      for (const e of batch) await walk(e, sub, out);
    } while (batch.length);
  }
}

export async function fromDataTransfer(dt) {
  const entries = [...(dt.items || [])].map((i) => i.webkitGetAsEntry?.()).filter(Boolean);
  if (!entries.length) return [...dt.files].map((file) => ({ file, dir: "" }));
  const out = [];
  for (const e of entries) await walk(e, "", out);
  return out;
}

export const fromInput = (fileList) => [...fileList].map((file) => {
  const parts = (file.webkitRelativePath || "").split("/");
  return { file, dir: parts.length > 1 ? parts.slice(0, -1).join("/") : "" };
});

export function splitFiles(list) {
  const audio = list.filter((x) => AUDIO_EXT.includes(ext(x.file.name)));
  const imagesByDir = {};
  list.filter((x) => IMAGE_EXT.includes(ext(x.file.name))).forEach((x) => { (imagesByDir[x.dir] ||= []).push(x.file); });
  const covers = {};
  Object.entries(imagesByDir).forEach(([dir, imgs]) => {
    if (!dir) return;
    const named = imgs.find((f) => COVER_NAMES.includes(stem(f.name)));
    if (named || imgs.length === 1) covers[dir] = named || imgs[0];
  });
  return { audio, covers };
}
